// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__LUaCX","desktop":"Sidebar_desktop__3DFbQ","benefits":"Sidebar_benefits__VRSkt","splash":"Sidebar_splash__n-SR6"};